<template>
  <div class="contian">
    <div class="bank-list">
      <div class="item">
        <span class="label">{{$t('mki18n.t00011')}}</span>
        <div class="text" v-if="payBankData">{{ payBankData.bank_name }} <span v-if="bankNum">({{bankNum}})</span></div>
      </div>
      <div class="item">
        <span class="label">{{$t('mki18n.t00012')}}</span>
        <div class="text">
          <img :src="bankForm.bank_img" class="logo" />
          {{ bankForm.receiver_bank_cn }}
        </div>
      </div>
    </div>
    <div class="type-title">
      {{$t('mki18n.t00013')}}
    </div>
<!--     <div class="header">-->
<!--       {{ $t("transferIntoAbroad.lang") }}-->
<!--     </div>-->
<!--     <div class="title-header">-->
<!--       <div class="img-left-box">-->
<!--          <img :src="bankForm.bank_img" class="bank-logo" />-->
<!--       </div>-->
<!--       <div class="content">-->
<!--         <div class="content-title">-->
<!--           {{ bankForm.receiver_bank_cn }}-->
<!--         </div>-->
<!--         <div class="tip">-->
<!--           <div class="tip-left">-->
<!--             {{ $t("transferIntoAbroad.lang0") }}-->
<!--           </div>-->
<!--           <div class="tip-right">-->
<!--             {{ $t("transferIntoAbroad.lang1") }}-->
<!--           </div>-->
<!--         </div>-->
<!--       </div>-->
<!--     </div>-->
    <!--  卡片层    -->
     <div class="card-content">
       <div class="card">
         <div class="card-left">
           {{ $t("transferIntoAbroad.lang2") }}
         </div>
         <div class="card-middle">
           {{ bankForm.receiver_name || '' }}
         </div>
         <div class="card-right" v-if="bankForm.receiver_name">
            <div class="tag-btn tag-btn-active" v-clipboard:copy="bankForm.receiver_name"
                 v-clipboard:success="onCopySuccess">
              {{ $t("transferIntoAbroad.lang9") }}
            </div>
         </div>
       </div>
       <div class="card card-sencond">
         <div class="card-left">
           <div class="top">
             {{ $t("transferIntoAbroad.lang3") }}
           </div>
           <div class="bottom">
             {{ $t("transferIntoAbroad.lang4") }}
           </div>
         </div>
         <div class="card-middle">
           {{ bankForm.receiver_card_hkd || '' }}
         </div>
         <div class="card-right" v-if="bankForm.receiver_card_hkd">
           <div class="tag-btn tag-btn-active" v-clipboard:copy="bankForm.receiver_card_hkd"
                v-clipboard:success="onCopySuccess">
             {{ $t("transferIntoAbroad.lang9") }}
           </div>
         </div>
       </div>
       <div class="card card-sencond">
         <div class="card-left">
           <div class="top">
             {{ $t("transferIntoAbroad.lang3") }}
           </div>
           <div class="bottom">
             {{ $t("transferIntoAbroad.lang5") }}
           </div>
         </div>
         <div class="card-middle">
           {{ bankForm.receiver_card_usd || '' }}
         </div>
         <div class="card-right" v-if="bankForm.receiver_card_usd">
           <div class="tag-btn tag-btn-active" v-clipboard:copy="bankForm.receiver_card_usd"
                v-clipboard:success="onCopySuccess">
             {{ $t("transferIntoAbroad.lang9") }}
           </div>
         </div>
       </div>
       <div class="card card-sencond">
         <div class="card-left">
           <div class="top">
             {{ $t("transferIntoAbroad.lang3") }}
           </div>
           <div class="bottom">
             {{ $t("transferIntoAbroad.lang6") }}
           </div>
         </div>
         <div class="card-middle">
           {{ bankForm.receiver_card_cny || '' }}
         </div>
         <div class="card-right" v-if="bankForm.receiver_card_cny">
           <div class="tag-btn tag-btn-active" v-clipboard:copy="bankForm.receiver_card_cny"
                v-clipboard:success="onCopySuccess">
             {{ $t("transferIntoAbroad.lang9") }}
           </div>
         </div>
       </div>
       <div class="card card-sencond">
         <div class="card-left">
           {{ $t("transferIntoAbroad.lang7") }}
         </div>
         <div class="card-middle">
           {{ bankForm.bank_simple_name || '' }}
         </div>
         <div class="card-right" v-if="bankForm.bank_simple_name">
           <div class="tag-btn tag-btn-active" v-clipboard:copy="bankForm.bank_simple_name"
                v-clipboard:success="onCopySuccess">
             {{ $t("transferIntoAbroad.lang9") }}
           </div>
         </div>
       </div>
       <div class="card card-sencond">
         <div class="card-left">
           SWIFT Code
         </div>
         <div class="card-middle">
           {{ bankForm.swift_code || '' }}
         </div>
         <div class="card-right" v-if="bankForm.swift_code">
           <div class="tag-btn tag-btn-active" v-clipboard:copy="bankForm.swift_code"
                v-clipboard:success="onCopySuccess">
             {{ $t("transferIntoAbroad.lang9") }}
           </div>
         </div>
       </div>
       <div class="card card-sencond">
         <div class="card-left">
           Bank Code
         </div>
         <div class="card-middle">
           {{ bankForm.bank_code || '' }}
         </div>
         <div class="card-right" v-if="bankForm.bank_code">
           <div class="tag-btn tag-btn-active" v-clipboard:copy="bankForm.bank_code"
                v-clipboard:success="onCopySuccess">
             {{ $t("transferIntoAbroad.lang9") }}
           </div>
         </div>
       </div>
       <div class="card card-sencond no-border">
         <div class="card-left">
           {{ $t("transferIntoAbroad.lang8") }}
         </div>
         <div class="card-middle">
           {{ bankForm.bank_address || '' }}
         </div>
         <div class="card-right" v-if="bankForm.bank_address">
           <div class="tag-btn tag-btn-active" v-clipboard:copy="bankForm.bank_address"
                v-clipboard:success="onCopySuccess">
             {{ $t("transferIntoAbroad.lang9") }}
           </div>
         </div>
       </div>

       <div  v-if="bankForm.fps_code" class="type-title">
         {{$t('mki18n.t00014')}}
       </div>
       <div class="fps-box" v-if="bankForm.fps_code">
         <div class="fps-header">
           <div class="tipsText">{{ $t('transferIntoAbroad.lang12') }}（{{ bankForm.fps_code_currency_name }}）</div>
           <div class="card-right" v-if="bankForm.fps_code">
             <div class="tag-btn tag-btn-active" v-clipboard:copy="bankForm.fps_code"
                  v-clipboard:success="onCopySuccess">
               {{ $t("transferIntoAbroad.lang9") }}
             </div>
           </div>
         </div>
         <div class="code">{{ bankForm.fps_code }}</div>
       </div>

       <div class="foot-pancel">
         <nav-buttons
           :isFixed="false"
           :showPrev="false"
           :nextText="$t('mki18n.t00015')"
           @on-next="handSubmit"
         />
       </div>


       <div class="foot-tip">
         <div class="tip-title">
           {{ $t("transferIntoAbroad.tips[0]") }}
         </div>
         <div class="tip-content">
           {{ $t("transferIntoAbroad.tips[1]") }}
         </div>
         <div class="tip-content">
           {{ $t("transferIntoAbroad.tips[2]") }}
         </div>
         <div class="tip-content">
           {{ $t("transferIntoAbroad.tips[3]") }}
         </div>
       </div>
     </div>
  </div>
</template>

<script>
   import { Toast } from "vant";
   import navButtons from "@/views/app-pages/components/navButtons.vue";

   export default {
     components: { navButtons },
     data(){
       return {
          bankForm:{},
         payBankData: ''
       }
     },
     computed: {
       bankNum(){
         if(this.payBankData && this.payBankData.bank_card.length > 0){
           const text = this.payBankData.bank_card.trim().replace(/\s+/g, '');
           return text.substring(text.length - 4);
         }
         return ''
       }
     },
     created() {
       this.init();
     },
     methods:{
       init(){
         const params = {
           id:this.$route.query.id
         }
         this.$apis.getRemittanceDetail(params).then(res =>{
             if(res){
               this.bankForm = res
             }
         });
         const card_id = this.$route.query.card_id;
         if(card_id){
           this.$apis
             .getBankCardInfo({ id: card_id })
             .then(res => {
               this.payBankData = res;
             })
         }
       },
      // 复制
       onCopySuccess(){
         Toast(this.$t("transferIntoAbroad.lang11"));
       },
       handSubmit(){
         const toastLoading = Toast.loading({
           duration: 0,
           forbidClick: true,
           loadingType: "spinner",
           message: this.$t("common.loading_text")
         });
         this.$router.push({
           path: "/app-pages/credentials-upload",
           query: { ...this.$route.query }
         }).finally(() =>{
           toastLoading.clear()
         })
       }
     }
   }
</script>

<style scoped lang="less">
@import '../styles/styles.less';
.bank-list{
  border-bottom: 20px solid #f6f7fa;
  .item{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 32px;
    font-weight: 500;
    .label{
      font-size: 30px;
    }
    .text{
      display: flex;
      align-items: center;
      .logo{
        width: 50px;
        height: 50px;
        object-fit: contain;
        margin-right: 10px;
      }
    }
  }
}
.type-title{
  padding: 20px 32px;
  font-size: 32px;
  font-weight: 500;
  color: #17161c;
  border-top: 1px solid #FAFAFA;
}
.contian{
  .header {
    margin: 24px 32px;
    font-size: 32px;
    font-weight: 500;
    color: #17161c;
    border-bottom: 1px solid #FAFAFA;
    padding-bottom: 16px;
  }
  .title-header{
    display: flex;
    padding-left: 32px;
    padding-top: 10px;
    .img-left-box{
      display: flex;
      justify-items: center;
      align-items: center;
      height: 80px;
      .bank-logo{
        width: 58px;
        height: 58px;
        object-fit: contain;
      }
    }
    .content{
      margin-left: 16px;
      .content-title{
        font-size: 28px;
        font-weight: 500;
        color: #17161c;
      }
      .tip{
        display: flex;
        .tip-left{
          font-size: 24px;
          font-weight: 400;
          color: #747377;
          line-height: 36px;
        }
        .tip-right{
          flex: 1;
          text-align: right;
          font-size: 24px;
          font-weight: 400;
          color: #747377;
          line-height: 36px;
          padding-left: 20px;
          padding-right: 32px;
        }
      }

    }
  }
  .card-content{
    // padding-left: 32px;
    // padding-right: 32px;
    .card{
      display: flex;
      border-bottom: 1px solid #FAFAFA;
      padding: 22px 32px;
      // margin-top: 22px;
      &.no-border {
        border-bottom: none;
      }
      .card-left{
        font-size: 28px;
        font-weight: 400;
        color: #747377;
        width: 128px;
        line-height: 36px;
        .bottom1{
          margin-left: -20px;
        }
      }
      .card-middle{
        font-size: 28px;
        font-weight: 500;
        color: #17161c;
        flex: 1;
        text-align: right;
        padding-right: 26px;
        line-height: 36px;
      }
      .card-right{
         text-align: right;
      }
    }
    .card-sencond{
      // margin-top: 20px;
    }
  }
  .foot-pancel{
    margin-top: 50px;
    margin-left: 46px;
    margin-right: 46px;
  }
}
.black-theme{
  .header{
    color: #FFFFFF;
    border-bottom-color: #323442;
  }
  .title-header{
    .content{
      .content-title{
        color: #FFFFFF;
      }
    }
  }
  .tip{
    .tip-left{
      color: #9D9D9F !important;
    }
    .tip-right{
      color: #9D9D9F !important;
    }
  }
  .card-content{
    .card{
      border-bottom-color: #323442;
      .card-left{
        color: #9D9D9F !important;
      }
      .card-middle{
        color: #FFFFFF;
      }
    }
  }
}
.foot-tip {
  margin: 0px 32px;
}
.fps-box {
  padding: 32px 16px;
  margin: 0px 16px;
  border-radius: 12px;
  border: 1px solid #FAFAFA;
  .fps-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .card-right {
      margin-left: auto;
    }
  }
  .tipsText {
    font-size: 28px;
    color: #747377;
  }
  .code {
    font-weight: 500;
    font-size: 32px;
    color: #17161c;
    line-height: 32px;
  }
}
</style>
